<template>
	<div class="cotent_news">
		<div class="content_top">
			<img src="@/assets/images/index/news.jpg" alt="" class="w100">
			<!-- <h3>Who We Are</h3> -->
		</div>
		
		<div class="content_icon">
            <div class="news_top">
                <h3>News</h3>
                <div class="menu_box">
                    <router-link to="/Company" class="">Company News</router-link>
                    <router-link to="/Industry" class="hover">Industry News</router-link>
                </div>
            </div>
			<ul>
			    <li v-for="(item,index) in piclist" >
                    <img :src="item.image" alt="" class="left_img"/>
                    <div class="text_container">
                        <h4>{{item.title}}</h4>
                        <p>{{item.description}}</p>
                        <div class="bottom">
                            <div class="time_box">
                                <img src="@/assets/images/icon/time.png" alt="" class="time"/>
                                <span>{{item.add_time}}</span>
                            </div>
                            <router-link class="detail" :to="`/newsdetail?cid=2&id=${item.id}`">
                                <img src="@/assets/images/icon/jiantou.png" alt="" class="time"/>
                                <span>View Detail</span>
                            </router-link>
                        </div>
                        
                    </div>
                </li>
			</ul>
            
		</div>
	</div>
</template>

<script>
    import axios from 'axios';
	export default {
		data() {
			return {
				piclist:[],
                id:''
			}
		},
        watch: {
            '$route.query.id'(newValue) {
              this.id = newValue; // 将新的参数值保存到组件的monitoredParam属性中
              // 执行其他操作或调用其他方法
               this.$nextTick(() => {
                  console.log(this.id)
                  window.location.reload()
              })
            },
        },
        mounted(){
        	var that = this;
            that.id = that.$route.query.cid;
            console.log(that.id)
        	axios({
        		method: 'get',
        		url:`${this.$apiYf}/newslistapi.php?catid=2`,
        		data: {
        			catid:2
        		},
        		headers: {'Content-Type': 'multipart/form-data'},
        	}).then((res) =>{
        		that.piclist=res.data.article_list;
        	    
        	})
            
        	
        },
        method:{
            
        }
	}
</script>

<style scoped lang="scss">
    .cotent_news{
        
        .content_icon{
        	width: 72.9%;margin:3vw auto;
        	h3{font-size: 48px;color: #ad1f24;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 100%;position: absolute;bottom: 0;left:0;
        		}
        	}
            .news_top{display: flex;margin: 44px 0;align-items: baseline;justify-content: space-between;}
            .menu_box{
                display: flex;
                a{display: block;width: 15vw;height: 45px;color: #333;text-align: center;line-height: 45px;
                    &.hover{background: #ad1f24;color: #fff;}
                }
            }
        	ul{

        		li{
        			margin-top: 2vw;padding-bottom: 2vw;border-bottom: solid 1px #ccc;display: flex;
                    .left_img{
                        width: 20vw;margin-right: 2vw;flex-shrink: 0;height:100%
                    }
                    .text_container{flex: 1;
                        h4{font-size: 24px;color: #333333;margin-bottom: 22px;
                            @media (max-width: 1440px) {
                                margin-bottom: 10px;
                            }
                        }
                        p{
                            font-size: 14px;
                            color:#666;line-height: 24px;margin-bottom: 60px;
                            @media (max-width: 1440px) {
                                margin-bottom: 10px;
                            }
                        }
                    }
                    .bottom{display: flex;justify-content: space-between;align-items: center;}
                    .time_box{display: flex;align-items: center;font-size: 14px;color: #333;
                        img{margin-right: 4px;}
                    }
                    .detail{
                        display: flex;align-items: center;cursor: pointer;
                        img{margin-right: 4px;}
                        span{
                            color: #185fad;width: 10vw;height: 30px;border: solid 1px #185fad;display: block;text-align: center;line-height: 30px;
                            &:hover{background:#185fad;color: #fff;}
                        }
                        
                    }
        		}
        	}
        }
        @keyframes jump {
        	0%,
        	100% {
        		transform: translateY(0);
        	}
        	50% {
        		transform: translateY(-10px);
        	}
        }
    }
	
</style>